"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { AnalyticsService } from '@/lib/firebase/services/analytics';

/**
 * 페이지 뷰 자동 추적 Hook
 * 페이지 변경 시 자동으로 페이지 뷰 이벤트 전송
 */
export function usePageTracking() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 페이지 변경 시 자동 추적
    AnalyticsService.trackPageView({
      page_title: document.title,
      page_location: window.location.href,
      page_path: pathname,
    });
  }, [pathname]);
}